import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Client logos image containing all brand logos
const CLIENT_LOGOS_IMAGE = 'https://customer-assets.emergentagent.com/job_3a8e81e0-2de4-4c76-829e-02137c446df7/artifacts/4f3y1v78_clients-logo.webp';

export const ClientsLogoSection = () => {
  return (
    <section data-testid="clients-logo-section" className="py-20 bg-gradient-to-b from-[#0a0a0a] to-[#121212]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Trusted Partners</p>
          <h2 className="font-montserrat text-3xl sm:text-4xl lg:text-5xl text-white mb-4">
            Over <span className="gradient-gold">1000+</span> Global Brands
          </h2>
          <p className="font-google-sans text-[#A1A1AA] text-base max-w-2xl mx-auto">
            Partnering with world-renowned hotels, resorts, and entertainment destinations across the globe
          </p>
        </div>

        {/* Logo Image Grid Container */}
        <div className="relative group">
          {/* Decorative border */}
          <div className="absolute -inset-1 bg-gradient-to-r from-[#D4AF37]/20 via-[#D4AF37]/5 to-[#D4AF37]/20 rounded-2xl blur-sm opacity-50 group-hover:opacity-75 transition-opacity duration-500"></div>
          
          {/* Main container */}
          <div className="relative bg-white rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl">
            <img
              src={CLIENT_LOGOS_IMAGE}
              alt="Our Global Client Partners - Hotels, Resorts, Entertainment Destinations"
              className="w-full h-auto rounded-lg"
              loading="lazy"
            />
          </div>
        </div>

        {/* View All Clients CTA */}
        <div className="text-center mt-12">
          <Link
            to="/clients"
            data-testid="view-all-clients-btn"
            className="inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] font-medium px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
          >
            View All Clients
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
